export default {
   originOpts: [
      {label: "已上传", value: 1},
      {label: "未上传", value: 2}
   ],
   retouchOpts: [
      {label: "未修图", value: 1},
      {label: "修图中", value: 2},
      {label: "已修图", value: 3},
   ],
   releaseOpts: [
      {label: "已发布", value: 1},
      {label: "未发布", value: 2}
   ],
   orderOpts: [
      {value: 1, label: "拍摄时间正序"},
      {value: 2, label: "拍摄时间倒序"},
      {value: 3, label: "上传时间正序"},
      {value: 4, label: "上传时间倒序"}
   ],
   timeTypeOpts: [
      {value: 1, label: "拍摄"},
      {value: 2, label: "上传"},
   ],
}
